import moment from 'moment'
import { SORT_TYPE, PROPERTY_TYPE } from '../../common/constants/classifications'

// 一覧の表示件数
export const LIMIT = 20

const formatStrings = ['YYYY-MM-DD', 'MM/DD/YYYY', 'YYYY/MM/DD']

/**
 * URLパラメータの不正な値を初期値に戻す
 */
export const validate = (props) => {
  let newProps = {}

  // destinationがある場合はdestinationを優先
  if (props.destination) {
    newProps.prefecture = undefined
  }

  // checkin が不正でないかのチェック
  if (props.checkin && moment(props.checkin, formatStrings).isValid()) {
    newProps.checkin = moment(props.checkin, formatStrings).format('YYYY-MM-DD')
  } else {
    newProps.checkin = undefined
  }

  // checkout が不正でないかのチェック
  if (props.checkout && moment(props.checkout, formatStrings).isValid()) {
    newProps.checkout = moment(props.checkout, formatStrings).format('YYYY-MM-DD')
  } else {
    newProps.checkout = undefined
  }

  if (newProps.checkin && newProps.checkout) {
    // checkout が checkin よりも日付が若い場合は入れ替える
    if (moment(newProps.checkout).isBefore(newProps.checkin)) {
      [newProps.checkin, newProps.checkout] = [newProps.checkout, newProps.checkin]
    }
    // 日付が同じ場合は checkout 日に1日足す
    if (moment(newProps.checkin).isSame(newProps.checkout)) {
      newProps.checkout = moment(newProps.checkin).add(1, 'days').format('YYYY-MM-DD')
    }
  }

  // adults が不正 または 15名以上の場合は 初期値（1名）に変換
  if ((props.adults && isNaN(props.adults)) ||
  (props.adults && !isNaN(props.adults) && parseInt(props.adults) > 15)) {
    newProps.adults = undefined
  }

  // price_min がisNaNの場合は指定なしに変換
  if (isNaN(props.price_min)) {
    newProps.price_min = undefined
  }
  // price_max がisNaNの場合は指定なしに変換
  if (isNaN(props.price_max)) {
    newProps.price_max = undefined
  }
  // price_minの値がprice_maxより大きい場合は入れ替える
  if (!isNaN(props.price_min) && !isNaN(props.price_max)) {
    if (parseInt(props.price_max) < parseInt(props.price_min)) {
      newProps.price_min = props.price_max
      newProps.price_max = props.price_min
    }
  }

  // room_types が配列の場合は初期値（すべて）に変換
  if (props.room_types && Array.isArray(props.room_types)) {
    newProps.room_types = undefined
  }

  // instantがtruthyの場合は'true'にする
  if (props.instant) {
    newProps.instant = 'true'
  }

  // spot_idがあって、sortがないときはsort=distance_ascにする
  if (props.spot_id && !props.sort) {
    newProps.sort = SORT_TYPE.DISTANCE_ASC
  }

  // sort=distance_ascで、destinationまたはspot_idがないとき
  if (props.sort == SORT_TYPE.DISTANCE_ASC && !(props.destination || props.spot_id)) {
    newProps.sort = undefined
  }

  return {
    offset: ((props.page || 1) - 1) * LIMIT,
    limit: LIMIT,
    ...props,
    ...newProps,
    page: undefined
  }
}

// selectorにマッチするinputのvalueを返す
export const getInputValue = (selector) => {
  const input = document.querySelector(selector)
  if (input) {
    return input.value
  }
}

export const appendToRef = (ref, element) => {
  if (element && ref) {
    if (element.parentElement != ref) {
      ref.appendChild(element)
    }
  }
}

// 建物タイプタイトル
export const getPropertyTypeTitle = (propertyTypes, { coupon }) => {
  const _propertyTypes = [].concat(propertyTypes)
  const suffix = {ja: '', en: ''}
  if (coupon) {
    suffix.ja = `「${coupon.title.replace(/クーポン$/, '')}」対象施設`
    suffix.en = `${coupon.title.replace(/クーポン$/, '').replace(/トラベル/, 'Travel')}` // TODO: i18n coupon title
    if (coupon.title == "全国旅行支援") {
      suffix.en = "National Travel Support Campaign"
    }
  }

  if (_propertyTypes.length === 1) {
    switch(_propertyTypes[0]) {
    case PROPERTY_TYPE.HOUSE:
      return { ja: `一戸建てタイプの${suffix.ja || '宿泊・民泊施設'}一覧`, en: `Houses${suffix.en}` }
    case PROPERTY_TYPE.APARTMENT:
      return { ja: `マンション/アパートタイプの${suffix.ja || '宿泊・民泊施設'}一覧`, en: `Apartments${suffix.en}` }
    case PROPERTY_TYPE.HOTEL:
      return { ja: `ホテル/旅館${suffix.ja ? 'の' + suffix.ja : ''}一覧`, en: `Hotels${suffix.en}` }
    case PROPERTY_TYPE.COTTAGE:
      return { ja: `コテージ${suffix.ja ? 'の' + suffix.ja : ''}一覧`, en: `Cottages${suffix.en}` }
    case PROPERTY_TYPE.BUNGALOW:
      return { ja: `バンガロー${suffix.ja ? 'の' + suffix.ja : ''}一覧`, en: `Bungalows${suffix.en}` }
    case PROPERTY_TYPE.GLAMPING:
      return { ja: `グランピング${suffix.ja ? 'の' + suffix.ja : '施設'}一覧`, en: `Glamping sites${suffix.en}` }
    default:
      break
    }
  }
  return { ja: `${suffix.ja || '宿泊・民泊施設'}一覧`, en: (suffix.en ? 'Accommodations for ' + suffix.en : '') }
}

export const ucfirst = (str) => {
  return `${str.charAt(0).toUpperCase()}${str.slice(1)}`
}
